/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SubjectInputs */

const de__field_subject = /** @type {(inputs: _Field_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fach`)
};

/**

* @param {_Field_SubjectInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_subject = /** @type {((inputs?: _Field_SubjectInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SubjectInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_subject(inputs)
});